
import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class Badge extends Vue {
  @Prop({default: false, type: Boolean}) readonly copy!: boolean;
  @Prop() readonly title!: string;
}
